import styled from "@emotion/styled";

const StyledUserMenu = styled.ul`
  display: flex;
  flex-direction: column;

  li {
    position: relative;
    list-style: none;

    &:not(:last-of-type) {
      border-bottom: 1px solid ${({ theme }) => theme.colors.tone.marble};
    }

    &:hover {
      background-color: ${({ theme }) => theme.colors.tone.sand};
    }
  }

  .UserMenu__link,
  .logout {
    display: flex;
    place-items: center;
    gap: ${({ theme }) => theme.space.space8 || "8px"};
    width: 100%;
    height: 100%;
    cursor: pointer;
    padding: ${({ theme }) => theme.space.space16};

    color: ${({ theme }) => theme.colors.tone.anthraciteDark};
    font-size: ${({ theme }) => theme.fontSizes.fontSize16};
    line-height: 24px;

    &:disabled {
      cursor: not-allowed;
      pointer-events: none;
    }

    svg {
      width: ${({ theme }) => theme.fontSizes.fontSize24};
    }
  }

  .UserMenu__guestSection {
    &:hover {
      background: none;
    }
  }

  .UserMenu__guestLabel {
    display: block;
    padding: ${({ theme }) =>
      `${theme.space.space16 || "16px"} ${theme.space.space16 || "16px"} ${
        theme.space.space4 || "4px"
      }`};
    color: ${({ theme }) => theme.colors.tone.anthracite};
    font-size: ${({ theme }) => theme.fontSizes.fontSize12};
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }

  .UserMenu__guestRow {
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.space.space8 || "8px"};
    width: 100%;
    min-height: 44px;
    padding: ${({ theme }) =>
      `${theme.space.space8 || "8px"} ${theme.space.space16 || "16px"}`};
    border: none;
    background: none;
    cursor: pointer;
    text-align: left;

    color: ${({ theme }) => theme.colors.tone.anthraciteDark};
    font-size: ${({ theme }) => theme.fontSizes.fontSize16};
    line-height: 24px;

    &:hover {
      background-color: ${({ theme }) => theme.colors.tone.sand};
    }

    span {
      flex: 1;
    }

    svg {
      flex-shrink: 0;
    }

    svg:first-of-type {
      width: ${({ theme }) => theme.fontSizes.fontSize24};
    }
  }

  .UserMenu__actions {
    display: flex;
    flex-direction: column;
    background: ${({ theme }) => theme.colors.tone.sand};
    text-align: center;
    color: ${({ theme }) => theme.colors.tone.black};
    padding: ${({ theme }) => theme.space.space16};
  }

  .UserMenu__actions > *:not(:first-of-type) {
    margin-top: 15px;
  }
`;

export { StyledUserMenu };
